import AmazonCart from './amazon-cart'

export default AmazonCart
